import { render, staticRenderFns } from "./terms-and-condition-card.vue?vue&type=template&id=b1516c64"
import script from "./terms-and-condition-card.vue?vue&type=script&lang=js"
export * from "./terms-and-condition-card.vue?vue&type=script&lang=js"
import style0 from "./terms-and-condition-card.vue?vue&type=style&index=0&id=b1516c64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports